import Andiamo from "../";

const routes = [
	{ name: "AnDIamo Lista PAI", path: "/andiamo/pai", component: Andiamo.AndiamoPaiListPage, meta: { title: "AnDIamo - Lista PAI" } },
	{ name: "AnDIamo Eventi PAI", path: "/andiamo/pai/eventi", component: Andiamo.AndiamoPaiEventiListPage, meta: { title: "AnDIamo - Eventi PAI" } },
	{ name: "AnDIamo View PAI", path: "/andiamo/pai/:idPai", component: Andiamo.AndiamoPaiViewPage, meta: { title: "AnDIamo - PAI" } },
	{ name: "AnDIamo Accessi", path: "/andiamo/erogazioni", component: Andiamo.AndiamoAccessiListPage, meta: { title: "AnDIamo - Accessi" } },
	// CONFERMATO da collaudo: questa pagina bypassava tutti i controlli
	// (blocco sospensione, idPei obbligatorio, codice accesso reale,
	// operatore da registro) - rimossa dal router, l'unico modo di
	// registrare un'erogazione resta la modale, raggiunta da Accessi o
	// dalla view del PAI.
	{ name: "AnDIamo Erogazioni Inviate", path: "/andiamo/erogazioni/inviate", component: Andiamo.AndiamoErogazioniInviateListPage, meta: { title: "AnDIamo - Erogazioni Inviate" } },
	{ name: "AnDIamo Lista Utenti", path: "/andiamo/utenti", component: Andiamo.AndiamoUtentiListPage, meta: { title: "AnDIamo - Utenti" } },
	{ name: "AnDIamo View Utente", path: "/andiamo/utenti/:codiceFiscaleOperatore/view", component: Andiamo.AndiamoUtenteViewPage, meta: { title: "AnDIamo - Dettaglio Utente" } },
	{ name: "AnDIamo Modifica Utente", path: "/andiamo/utenti/:codiceFiscaleOperatore", component: Andiamo.AndiamoUtenteEditPage, meta: { title: "AnDIamo - Modifica Utente" } },
];
export default routes;
